import React from 'react';
import {
  Grid,
  CircularProgress,
  Paper,
  Box,
  Button,
} from '@material-ui/core';

import { Helmet } from 'react-helmet';

import Commify from 'comma-number';
import { isMobile } from 'react-device-detect';
import Moment from 'moment';

import APIServer from '../../config/server.conf.json';

import './Lotto.css';

export default class LottoMakeNumber extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: {
        number: true
      }
    }
  }

  loadNumberForThisWeek = () => {
    return fetch(`${APIServer.baseUrl}/api/v1/lotto/make/get`);
  }

  numberTimer = () => {
    let diff = Moment.duration(Moment(this.state.data.next_tick).diff(Moment()));

    this.setState({
      ...this.state,
      remain_time: `${diff.hours() < 10 ? '0':''}${diff.hours()}:${diff.minutes() < 10 ? '0':''}${diff.minutes()}:${diff.seconds() < 10 ? '0':''}${diff.seconds()}`
    }, () => {
      if(diff.hours() === 0 && diff.minutes() === 0 && diff.seconds() < 0) {
        this.loadNumberForThisWeek()
          .then((resp) => resp.json())
          .then((resp) => {
            if(resp.status === 200) {
              let remain_time = undefined;
              let data = resp.data;

              data.rows = data.rows.map((e) => {
                return {
                  ...e,
                  number: e.number.length === 6 ? e.number.sort(function(a, b) {
                    return a - b;
                  }):e.number
                }
              });

              if(data.next_tick === undefined) {
                this.setState({
                  isLoading: {
                    number: false,
                  },
                  data: data
                });
                clearInterval(this.timer);
                remain_time = undefined;
              } else {
                if(data.rows[0].number.length === 6 && data.rows[0].number.indexOf(0) === -1) {
                  data.rows.unshift({
                    number: [0,]
                  });
                }

                diff = Moment.duration(Moment(data.next_tick).diff(Moment()));

                remain_time = `${diff.hours() < 10 ? '0':''}${diff.hours()}:${diff.minutes() < 10 ? '0':''}${diff.minutes()}:${diff.seconds() < 10 ? '0':''}${diff.seconds()}`;
              }

              if(data.rows[0].number.length < 6) {
                for(let i=data.rows[0].number.length;i<6;i++) {
                  data.rows[0].number.push(0);
                }
              }

              this.setState({
                isLoading: {
                  number: false,
                },
                data: data,
                remain_time: remain_time
              });
            }
          });
      }
    });
  }

  componentDidMount() {
    this.loadNumberForThisWeek()
      .then((resp) => resp.json())
      .then((resp) => {
        if(resp.status === 200) {
          let remain_time = undefined;
          let data = resp.data;

          if(data.rows.length) {
            data.rows = data.rows.map((e) => {
              return {
                ...e,
                number: e.number.length === 6 ? e.number.sort(function(a, b) {
                  return a - b;
                }):e.number
              }
            });

            if(data.next_tick) {
              this.timer = setInterval(this.numberTimer, 1000);
              if(data.rows[0].number.length === 6 && data.rows[0].number.indexOf(0) === -1) {
                data.rows.unshift({
                  number: [0,]
                });
              }

              let diff = Moment.duration(Moment(data.next_tick).diff(Moment()));

              remain_time = `${diff.hours() < 10 ? '0':''}${diff.hours()}:${diff.minutes() < 10 ? '0':''}${diff.minutes()}:${diff.seconds() < 10 ? '0':''}${diff.seconds()}`;
            }

            if(data.rows[0].number.length < 6) {
              for(let i=data.rows[0].number.length;i<6;i++) {
                data.rows[0].number.push(0);
              }
            }

            this.setState({
              isLoading: {
                number: false,
              },
              data: data,
              remain_time: remain_time
            });
          } else {
            this.setState({
              isLoading: {
                number: false,
              },
              data: resp.data,
              remain_time: undefined
            });
          }
        }
      });
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  getBallClass = (num) => {
    let cls = '';

    if(num >= 1 && num <= 10) {
      cls = 'ball1';
    } else if(num >= 11 && num <= 20) {
      cls = 'ball2';
    } else if(num >= 21 && num <= 30) {
      cls = 'ball3';
    } else if(num >= 31 && num <= 40) {
      cls = 'ball4';
    } else if(num >= 41 && num <= 45) {
      cls = 'ball5';
    } else if(num === 0) {
      cls = 'ball0';
    }

    return cls;
  }

  goResult = event => {
    event.preventDefault();
    window.location.href = "/lotto/make_number_result";
  }

  render() {
    return (
      <Grid container style={{ padding: 10, minHeight: 450 }} spacing={3}>
        <Helmet
          title="로또 번호 생성"
          meta={[
            { name: "description", content: "로또 번호 생성" },
            { name: "keywords", content: "toolbox, tbx, 툴박스, lotto, lotto number, generator, 로또, 로또 번호, 로또 번호 생성" },
            { property: "og:title", content: "로또 번호 생성 - TBX" },
            { property: "og:description", content: "로또 번호 생성 - TBX" },
            { property: "og:title", content: "로또 번호 생성 - TBX" },
          ]}
        />
        {this.state.isLoading.number &&
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <CircularProgress color="secondary" size={50} />
        </Grid>}
        {!this.state.isLoading.number && this.state.data &&
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <Paper variant="outlined" style={{ padding: 10, margin: 10 }}>
            <Grid container justify="center" spacing={3}>
              <Grid item>
                <div><b>번호 굽는 시간</b></div>
                <div><b>월요일 00:00 ~ 금요일 22:00 (2시간 간격)</b></div>
                <div><b>총 10게임 (60개 번호)</b></div>
              </Grid>
            </Grid>
          </Paper>
          {this.state.data.rows.map((e, i) => {
            return (
            <Paper variant="outlined" style={{ padding: 10, margin: 10, backgroundColor: i % 2 ? 'rgba(0, 0, 0, 0.04)':'' }} key={i}>
              <Grid container justify="center" spacing={3}>
                {/* <Grid item key={`${i}-idx`}>
                  <span className={`ball_645 lrg ${this.getBallClass(0)}`}>{`{`}{this.state.data.rows.length-i}{`}`}</span>
                </Grid>
                <Grid item key={`${i}-padding`}>
                  &nbsp;
                </Grid> */}
                {e.number.map((ee, ii) => {
                  return (
                  <Grid item key={ii}>
                    <span className={`ball_645 lrg ${this.getBallClass(ee)}`} key={ii}>{ee === 0 ? '?':ee}</span><br/>
                    <span>{ee === 0 && e.number.indexOf(0) === ii ? this.state.remain_time:''}</span>
                  </Grid>)
                })}
              </Grid>
            </Paper>)
          })}
          {this.state.data.rows.length === 0 &&
          <Box style={{ padding: 20 }}>
            <Button variant="contained" color="secondary" size="large" onClick={this.goResult}>
              '이번주 번호' 결과 보기
            </Button>
          </Box>
          }
        </Grid>}
      </Grid>
    );
  }
}